import { render, staticRenderFns } from "./Prague.vue?vue&type=template&id=12547cfd"
import script from "./Prague.vue?vue&type=script&lang=js"
export * from "./Prague.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports